import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export default function AdminDesignEnquiries() {
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/admin/design-enquiries`).then((r) => setItems(r.data)); }, []);

  return (
    <div className="fade-in" data-testid="admin-design-enquiries-page">
      <div className="mb-10">
        <div className="font-micro text-[#8A8680] mb-3">Bespoke</div>
        <h1 className="font-serif text-[#EDE4D3] text-5xl">Design Uploads.</h1>
      </div>

      {items.length === 0 ? (
        <div className="p-10 text-center font-serif text-[#8A8680] text-2xl" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
          No design uploads yet.
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="admin-design-list">
          {items.map((d) => (
            <div key={d.id} className="p-6" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
              {d.storage_path && (
                <div className="aspect-[4/3] mb-5 overflow-hidden" style={{ background: "#0B0B0C" }}>
                  {(d.content_type || "").startsWith("image") ? (
                    <img src={`${API}/files/${d.storage_path}`} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center font-micro text-[#B8895C]">{d.original_filename || "Attachment"}</div>
                  )}
                </div>
              )}
              <div className="font-serif text-[#EDE4D3] text-xl">{d.name}</div>
              <div className="font-micro text-[#8A8680] mt-1">{d.phone} · {d.email || "—"}</div>
              <div className="mt-4 space-y-2 text-sm text-[#D8D6D1]">
                {d.room && <div><span className="font-micro text-[#8A8680]">Room:</span> {d.room}</div>}
                {d.budget && <div><span className="font-micro text-[#8A8680]">Budget:</span> {d.budget}</div>}
                {d.wood_preference && <div><span className="font-micro text-[#8A8680]">Wood:</span> {d.wood_preference}</div>}
                {d.fabric_preference && <div><span className="font-micro text-[#8A8680]">Fabric:</span> {d.fabric_preference}</div>}
                {d.notes && <div className="mt-3 text-[#8A8680]">{d.notes}</div>}
              </div>
              <div className="font-micro text-[#8A8680] mt-5">{d.created_at?.slice(0, 16).replace("T", " ")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
